import { render, staticRenderFns } from "./nuovo.vue?vue&type=template&id=958ab9a4&scoped=true&"
import script from "./nuovo.vue?vue&type=script&lang=js&"
export * from "./nuovo.vue?vue&type=script&lang=js&"
import style0 from "./nuovo.vue?vue&type=style&index=0&id=958ab9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958ab9a4",
  null
  
)

export default component.exports